module.exports = __webpack_public_path__ + "img/mystic-miners-1.d13be776.webp";